module.exports = __webpack_public_path__ + "img/pattern.3bb6fa11.png";